import { createBrowserHistory } from "history";

const historyRouter = createBrowserHistory({ window });
export default historyRouter;
